import React, { Component } from 'react';
import './Footer.css';
import { translate } from 'react-i18next';
class Footer extends Component {

  render() {
    return (
      <div className="Footer">
        <div className="d-flex justify-content-left">
          <small className="px-6"> &copy; relaystream Todos os direitos reservados.</small>
          <div className="justify-content-end footer-right-text">
            <a className="aboutPage" href="https://relaystream.com.br/about.html" target="_blank">Quem somos</a>
            <a className="privacyPage" href="https://relaystream.com.br/politica.html" target="_blank">Privacidade</a>
            <a className="privacyPage" href="https://relaystream.com.br/privacy-facebook.html" target="_blank">Facebook-Privacidade</a>
            <a className="termsPage" href="https://relaystream.com.br/termos.html" target="_blank">Termos e Condições</a>
            {/* <a className="privacyPage" href="https://myaccount.google.com/permissions" target="_blank">Permissão do Google</a> */}
            {/* <a className="privacyPage" href="https://www.youtube.com/static?template=terms" target="_blank">Termos do YouTube</a> */}
            {/* <a className="termsPage" href="https://policies.google.com/privacy?hl=en-US" target="_blank">Privacidade Google</a> */}
            <a className="termsPage ml-2" href="/contact-us" target="_blank">Contate-Nos</a>
          </div>
        </div>
      </div>

    );
  }
}

export default translate('translations')(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js